import { styled } from "styled-components";

export const HiddenFileInput = styled.input`
  display: none;
`;
